import { Divider, Skeleton } from '@mui/material';

import { useMainNavigationStyles } from './useMainNavigationStyles';

export const MainNavigationSkeleton = () => {
  const { classes } = useMainNavigationStyles();

  return (
    <div className={classes.root}>
      <nav>
        <Skeleton className={classes.skeleton} variant="rectangular" />
        <Skeleton className={classes.skeleton} variant="rectangular" />
        <Skeleton className={classes.skeleton} variant="rectangular" />
        <Skeleton className={classes.skeleton} variant="rectangular" />
        <Skeleton className={classes.skeleton} variant="rectangular" />
        <Divider sx={{ marginTop: 3, marginBottom: 3 }} />
        <Skeleton className={classes.skeleton} variant="rectangular" />
        <Skeleton className={classes.skeleton} variant="rectangular" />
      </nav>
    </div>
  );
};
